import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepTwo = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [errors, setErrors] = useState(null);
    const [alert, setAlert] = useState([]);
    const [rows, setRows] = useState([
        { id: 1, jobTitle: '', employer: '', location: '', lengthOfService: '', isValid: true },
        { id: 2, jobTitle: '', employer: '', location: '', lengthOfService: '', isValid: true },
        { id: 3, jobTitle: '', employer: '', location: '', lengthOfService: '', isValid: true },
        { id: 4, jobTitle: '', employer: '', location: '', lengthOfService: '', isValid: true }
    ]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            const data = storedData.previousEmployment || null;
            if (data) {
                const newRows = rows.map((row, index) => {
                    if (data[index]) {
                        return { ...row, ...data[index], isValid: true };
                    }
                    return row;
                });

                if (data.length > rows.length) {
                    newRows.push(...data.slice(rows.length).map(item => ({ ...item, id: rows.length + 1, isValid: true })));
                }
               
                setRows(newRows);
            }
        }
    }, []);

    const handleOnChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        const allFilled = handleFilled(newRows[index]);
        if (index < rows.length - 1) {
            newRows[index + 1].isValid = allFilled;
        }
        setRows(newRows);
    }

    const handleFilled = (item) => {
        return item?.jobTitle !== '' && item?.employer !== '' && item?.location !== '' && item?.lengthOfService !== '';
    }

    const handleSubmit = async () => {
        try {
            const formData = rows.filter(item => item.isValid === true && false === handleFilled(item));
            if (formData.length > 0) {
                setErrors("Please fill data");
                window.scrollTo(0, 0);
                return;
            }
            const modifiedJobs = rows?.map(({ jobTitle, employer, location, lengthOfService }) => ({ jobTitle, employer, location, lengthOfService }));
            setErrors(null);
            setAlert(CustomSweetAlert({ type: "loading" }));
            const url = `/HSInduction/SubmitPreviousEmployment?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
            const method = `post`;
            const response = await fetch(apiURL + url, {
                method,
                headers: [
                    ["Content-Type", "application/json"],
                    ["Content-Type", "text/plain"]
                ],
                body: JSON.stringify(modifiedJobs),
            });
            if (response.status === 200) {
                handleNext(modifiedJobs);
            } else {
                showErrorAlert(`Save previous employment failed`);
            }
        } catch (e) {
            showErrorAlert("Failed to submit data");
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    const handleAddMoreRow = () => {
        const isValid = rows[rows.length - 1].isValid;
        setRows([...rows, { id: rows.length + 1, jobTitle: '', employer: '', location: '', lengthOfService: '', isValid }])
    }

    const handleRemoveOption = (index) => {
        const newItems = [...rows];
        newItems.splice(index, 1);
        setRows(newItems);
    }

    return (<>
        <Row>
            {alert}
            <Col sm={12} md={12} className='mb-2'>
                <h2>2. Previous Employment</h2>
                <span>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12} className='mt-2'>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th width="3%"></th>
                            <th><h5>Job Title</h5></th>
                            <th><h5>Employer</h5></th>
                            <th><h5>Location</h5></th>
                            <th><h5>Length of Service</h5></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {errors && <tr>
                            <td colSpan={5}>
                                <Form.Text className="text-danger"><h6 className='text-center pt-2'> <span className="star">*</span> {errors}</h6></Form.Text>
                            </td>
                        </tr>}
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td width="3%" ><strong>{index + 1}</strong></td>
                                <td>
                                    <Form.Group className='px-0 py-2'>
                                        <Form.Control type="text"
                                            value={row.jobTitle}
                                            disabled={!row.isValid}
                                            onChange={(e) => handleOnChange(index, 'jobTitle', e.target.value)}
                                            className={errors?.jobTitle ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group className='px-0 py-2'>
                                        <Form.Control type="text"
                                            value={row.employer}
                                            disabled={!row.isValid}
                                            onChange={(e) => handleOnChange(index, 'employer', e.target.value)}
                                            className={errors?.employer ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group className='px-0 py-2'>
                                        <Form.Control type="text"
                                            value={row.location}
                                            disabled={!row.isValid}
                                            onChange={(e) => handleOnChange(index, 'location', e.target.value)}
                                            className={errors?.location ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        />
                                    </Form.Group>
                                </td>
                                <td>
                                    <Form.Group className='px-0 py-2'>
                                        <Form.Control type="text"
                                            value={row.lengthOfService}
                                            disabled={!row.isValid}
                                            onChange={(e) => handleOnChange(index, 'lengthOfService', e.target.value)}
                                            className={errors?.lengthOfService ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                        />
                                    </Form.Group>
                                </td>
                                <th>
                                    <Button
                                        className="btn-link"
                                        size="sm"
                                        onClick={() => handleRemoveOption(index)}
                                        variant={"danger"}
                                        style={{ margin: "0px", padding: "0px" }}
                                    >
                                        <i className="fas fa-times"></i>
                                    </Button></th>

                            </tr>
                        ))}
                        <tr>
                            <td colSpan={6}><Button onClick={handleAddMoreRow}> <i className="fa fa-plus"></i> Add more</Button></td>
                        </tr>
                    </tbody>
                </Table>
            </Col >
        </Row >
        <Row>
            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>
    </>
    );
};

export default StepTwo;